// HYCLIC/UNIPA sources are independent observations. The radar is displayed
// only while its latest source frame is fresh; no value feeds WS Now decisions.
import { enforceObservationLayerOrder } from '../lib/observation-layer-order.js';

const API = 'https://api.weathersicily.it/v1/unipa';
const RADAR_SOURCE = 'ws-unipa-radar-source';
const RADAR_LAYER = 'ws-unipa-radar-layer';
const state = { map: null, radarEnabled: false, radarFrames: [], radarBounds: null, currentFrame: '', radarTimer: null, referenceTime: null };

function note(message) {
    const element = document.getElementById('unipaStatus');
    if (element) element.textContent = message;
}
function clearRadarImage() {
    if (!state.map) return;
    if (state.map.getLayer(RADAR_LAYER)) state.map.removeLayer(RADAR_LAYER);
    if (state.map.getSource(RADAR_SOURCE)) state.map.removeSource(RADAR_SOURCE);
    state.currentFrame = '';
}
// Only pair with the national frame actually on screen, never the live cursor.
export function setUnipaRadarReference(time) {
    state.referenceTime = Number.isFinite(time) ? time : null;
    showRadarAt(state.referenceTime);
}

export function alignedUnipaFrame(frames, time) {
    if (!Number.isFinite(time)) return null;
    let chosen = null;
    for (const frame of frames) {
        const at = Date.parse(frame.time_utc);
        if (Number.isFinite(at) && at <= time && time - at <= 5 * 60000
            && (!chosen || at > Date.parse(chosen.time_utc))) chosen = frame;
    }
    return chosen;
}

function showRadarAt(time) {
    if (!state.radarEnabled || !state.radarBounds || !state.radarFrames.length) {
        clearRadarImage(); return;
    }
    const chosen = alignedUnipaFrame(state.radarFrames, time);
    if (!chosen) { clearRadarImage(); return; }
    if (chosen.url === state.currentFrame) return;
    const [[south, west], [north, east]] = state.radarBounds;
    clearRadarImage();
    state.map.addSource(RADAR_SOURCE, { type: 'image', url: new URL(chosen.url + '?render=clean-legend-2', API).toString(),
        coordinates: [[west, north], [east, north], [east, south], [west, south]] });
    const before = state.map.getStyle().layers.find(layer =>
        ['ws-blitz', 'ws-stations-symbols'].includes(layer.id))?.id;
    state.map.addLayer({ id: RADAR_LAYER, type: 'raster', source: RADAR_SOURCE,
        paint: { 'raster-opacity': .78, 'raster-fade-duration': 0 } }, before);
    enforceObservationLayerOrder(state.map);
    state.currentFrame = chosen.url;
}
async function refreshRadar() {
    if (!state.radarEnabled) return;
    try {
        const response = await fetch(`${API}/radar`, { cache: 'no-store' });
        const payload = await response.json();
        if (!response.ok || !payload.success || !payload.data) throw new Error('UNIPA radar unavailable');
        const data = payload.data;
        if (!state.radarEnabled) return;
        state.radarFrames = data.active ? data.frames || [] : [];
        state.radarBounds = data.bounds || null;
        if (data.active) {
            note(`HYCLIC · Università di Palermo · radar aggiornato alle ${new Date(data.latest_time_utc).toLocaleTimeString('it-IT', {hour:'2-digit',minute:'2-digit',timeZone:'Europe/Rome'})}`);
            showRadarAt(state.referenceTime);
        } else {
            clearRadarImage();
            note(`HYCLIC · Università di Palermo · radar non aggiornato${data.latest_time_utc ? ` (ultimo frame ${new Date(data.latest_time_utc).toLocaleString('it-IT', {timeZone:'Europe/Rome'})})` : ''}`);
        }
    } catch (error) {
        clearRadarImage();
        note('HYCLIC · Università di Palermo · radar temporaneamente non disponibile');
    }
}
export function initUnipa(map) { state.map = map; }
export async function setUnipaRadarEnabled(enabled) {
    if (state.radarEnabled === enabled) return;
    state.radarEnabled = enabled;
    if (enabled) {
        await refreshRadar();
        if (state.radarEnabled) state.radarTimer = setInterval(() => { if (!document.hidden) refreshRadar(); }, 60000);
    } else {
        if (state.radarTimer) clearInterval(state.radarTimer);
        state.radarTimer = null;
        state.referenceTime = null;
        state.radarFrames = [];
        clearRadarImage();
        note('HYCLIC · Università di Palermo · fonte radar disattivata');
    }
}
